
import { EventAggregator, EventList } from 'app/shared/utility/EventAggregator';
import { Injectable } from '@angular/core';

@Injectable()
export class SpinnerService {
    private callsPending: number = 0;

    public showProcessingIndicator() {
        EventAggregator.publish(EventList.processingIndicator, true);
        this.callsPending++;
    }

    public hideProcessingIndicator() {
        this.callsPending--;
        if (this.callsPending <= 0) { EventAggregator.publish(EventList.processingIndicator, false); }
    }
}
